import { useEffect, useState } from 'react';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    __tcfapi?: CallableFunction;
  }
}

const defaultValues: any = false;

const useConsentMode = () => {
  const [values, setValues] = useState(defaultValues);

  useEffect(() => {
    if (!window.__tcfapi) {
      setValues({});
      return;
    }
    window.__tcfapi('addEventListener', 2, (tcData) => {
      setValues(tcData);
    });
  }, []);
  return values;
};

export default useConsentMode;
